module.exports = __webpack_public_path__ + "img/referra-white-logo-234x54.4639668d.png";